/**
 * map.js
 */
import $ from "jquery";
import Drupal from "Drupal";
import drupalSettings from "drupalSettings";
import Feature from 'ol/Feature';
import Map from 'ol/Map';
import Overlay from 'ol/Overlay';
import Point from 'ol/geom/Point';
import TileJSON from 'ol/source/TileJSON';
import VectorSource from 'ol/source/Vector';
import View from 'ol/View';
import {Icon, Style} from 'ol/style';
import {Tile as TileLayer, Vector as VectorLayer, Layer} from 'ol/layer';
import {useGeographic,transform} from 'ol/proj';
import OSM from 'ol/source/OSM';

(function ($, Drupal, drupalSettings) {

  'use strict';

  Drupal.behaviors.map = {


    generateMap: function(markers,mapcontainerId,current){

      const rasterLayer = new TileLayer({
        source: new OSM(),
      });

      useGeographic();

      var map = new Map({
        layers: [rasterLayer],
        target: document.getElementById(mapcontainerId),
      });

      markers.each(function (e){
        var id = $(this).attr('id');
        var lat = $(this).data('lat');
        var lon = $(this).data('lon');

        var iconFeature = new Feature({
          geometry: new Point([lon,lat])
        });

        var iconStyle = new Style({
          image: new Icon({
            anchor: [0.5, 46],
            anchorXUnits: 'fraction',
            anchorYUnits: 'pixels',
            src: '/themes/custom/saipem_theme/source/icons/marker.svg',
          }),
        });
        iconFeature.setStyle(iconStyle);

        if(drupalSettings.override_saipem){
          var iconStyle = new Style({
            image: new Icon({
              anchor: [0.5, 46],
              anchorXUnits: 'fraction',
              anchorYUnits: 'pixels',
              src: '/themes/custom/saipem_theme/source/icons/override_marker.svg',
            }),
          });
          iconFeature.setStyle(iconStyle);
        }


        const vectorSource = new VectorSource({
          features: [iconFeature],
        });

        const vectorLayer = new VectorLayer({
          source: vectorSource,
        });


        if(id == current)
        {
          $(this).addClass('active');
          map.setView(new View({
            center:  [lon,lat],
            zoom: 3,
          }));
          map.addLayer(vectorLayer);
        }
        else
        {
          if(!current)
          {
            map.setView(new View({
              center:  [lon,lat],
              zoom: 3,
            }));
            map.addLayer(vectorLayer);
          }
        }


        $(this).find('.marker-link').click(function (el){
          el.preventDefault();
          $('#' + mapcontainerId + ' .ol-viewport').remove();
          $('#' + mapcontainerId).removeData('loadMap');

          $(this).closest('.map-menu').find('.map-marker').removeClass('active');
          $(this).closest('.map-marker').addClass('active');

          Drupal.behaviors.map.generateMap($(this).closest('.map-marker'),mapcontainerId,false);
        });



      });
    },

    attach: function (context, settings) {

      once('loadMap', 'div.map', context).forEach(
        function (element) {
          var id = $(element).attr('id');

          var current = window.location.hash.substr(1);

          if (typeof(current) == "undefined")
          {
            current = false;
          }


          $(element).closest('.map-container').find('.map-menu').each(function(mapmenu){
            Drupal.behaviors.map.generateMap($(this).find('.map-marker'),id,current);
          });

        }
      );

      once('loadMapinTabs','div.saipem--tabs',context).forEach(
        function(element)
        {
          $(element).find('a.nav-link').click(function(e){
            var tab = $(this).attr('aria-controls');
            var id =  $('#'+tab).find('.map-container>.map').attr('id');

            setTimeout(function (){

              $('#'+tab).find('.map-menu').each(function(mapmenu){
                $('#' + id + ' .ol-viewport').remove();
                $('#' + id).removeData('loadMap');
                Drupal.behaviors.map.generateMap($(this).find('.map-marker'),id,false);
              });

            }, 1000);
          });
        }
      );

    }
  };




})(jQuery, Drupal, drupalSettings);
